import { useFeatureTags } from 'src/hooks/useFeatureTags';
import { FeatureTagsContext } from 'src/stores/FeatureTags';
import type { ProviderProps } from 'src/types/provider';

const FeatureTagsProvider: React.FC<ProviderProps> = ({ children }) => {
  const { featureTags, isLoading } = useFeatureTags();
  if (isLoading) return null;

  return <FeatureTagsContext.Provider value={featureTags ?? []}>{children}</FeatureTagsContext.Provider>;
};

export { FeatureTagsProvider };
